import Swiper from 'swiper';

function sliderEvents() {
  new Swiper('.swiper-events', {
    grabCursor: true,
    spaceBetween: 8,
    breakpoints: {
      600: {
        spaceBetween: 12,
        slidesPerView: 1.5,
      },
      1110: {
        spaceBetween: 24,
        slidesPerView: 2.5,
      }
    }
  });
}
sliderEvents();